import { Dialog, DialogContent, DialogActions, Button, IconButton, Grid, Box, Tooltip, tooltipClasses, FormGroup, FormControlLabel, Switch, CircularProgress, Backdrop } from '@mui/material';
import { styled } from '@mui/material/styles';
import { PiInfoBold } from "react-icons/pi";
import CreatePriceStr from '../../common/common/CreatePriceStr';
import { IoClose } from 'react-icons/io5';
import { FaTrash } from 'react-icons/fa';
import { useState, useEffect, useRef } from 'react';
import IconImage from "../../../media/site_media/illustrations/Icon-Image@2x.png";
import axios from "axios";
import { resizeImageFromFile } from '../../common/resizeImage';
import InfoIcon from '@mui/icons-material/Info';
import { useSearchParams } from 'react-router-dom';
const paths = require('../../../paths.json');


const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: '#222222 !important',
    color: '#ffffff',
    boxShadow: theme.shadows[1],
    fontSize: 11,
    margin: '0px'
  },
}));

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 36,
  height: 20,
  marginLeft: 5,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 20,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(7px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(15px)',
      color: '#fff !important',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: 'var(--brand-color)',
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 16,
    height: 16,
    borderRadius: 40,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 100,
    opacity: 1,
    backgroundColor:
      theme.palette.mode === 'dark' ? 'rgba(255,255,255,.35)' : 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
  },
}));


const EditCollections = ({ open, onClose, collection, onUpdate, currencySymbol, currencySymbolPost, editCollectionTitle, editCollectionThumbnail, editCollectionPrice, editCollectionId, minBuyNowPrice, influencer, currency, editCollectionBuyNowActive, editCollectionPriceStr, setState, editingCourse, ...props }) => {
  const [searchParams] = useSearchParams()
  const current_page_view = searchParams.get("page");
  const isCourses = (current_page_view === 'courses' || editingCourse === true)
  const [collectionName, setCollectionName] = useState('');
  const [price, setPrice] = useState('');
  const [priceStr, setPriceStr] = useState('');
  const [buyNowActive, setBuyNowActive] = useState(false);
  const [error, setError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [imageFileTypeError, setImageFileTypeError] = useState('');
  const [showError, setShowError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const imageInput = useRef(null);
  const [imageFile, setImageFile] = useState('')
  const [imagePreviewUrl, setImagePreviewUrl] = useState('');
  const [isCreating, setIsCreating] = useState(false);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const isCreateDisabled = !collectionName || (buyNowActive && (!priceStr || editCollectionPrice < minBuyNowPrice)) || isCreating === true;

  useEffect(() => {
    if (editCollectionPrice > 0) {
      let processed_str = '';
      if (editCollectionPrice % 100 === 0) {
        processed_str = (editCollectionPrice / 100).toString();
      } else if (editCollectionPrice % 10 === 0) {
        processed_str = (editCollectionPrice / 100).toFixed(1);
      } else {
        processed_str = (editCollectionPrice / 100).toFixed(2);
      }
      setState({ editCollectionPriceStr: processed_str });
      setPriceStr(processed_str);
    } else {
      setPriceStr('');
      setState({ editCollectionPriceStr: '' });
    }
  }, [editCollectionPrice, open]);

  // Update state when props change
  useEffect(() => {
    setCollectionName(editCollectionTitle || '');
    setPrice(editCollectionPrice ? (editCollectionPrice / 100).toFixed(2) : ''); // Convert from cents
    
    // Set buyNowActive to true if there is a price
    if (editCollectionPrice > 0) {
      setBuyNowActive(true);
      setState({ editCollectionBuyNowActive: true });
    } else {
      setBuyNowActive(editCollectionBuyNowActive);
    }

  }, [editCollectionTitle, editCollectionPrice, editCollectionBuyNowActive, open]);

  const handleUpdate = async () => {
    // Validate minimum price if buy now is active
    if (buyNowActive && editCollectionPrice < 100) {
      setError(true);
      setErrorMessage('Minimum price is 1.00');
      return;
    }

    setIsCreating(true);

    const form_data = new FormData();
    form_data.append('influencer', influencer)
    form_data.append('currency', currency)
    form_data.append('collection_id', editCollectionId)
    form_data.append('collection_name', collectionName)
    form_data.append('price', buyNowActive ? editCollectionPrice : null)
    let thumbnail_base64 = ''
    if (imageFile){
      thumbnail_base64 = await resizeImageFromFile(imageFile, 1920);
      form_data.append('thumbnail', thumbnail_base64)
    }
    axios({
      method: 'post',
      url: paths.BACKEND_URL + "api/influencer/edit_collection_v2",
      headers: {
        'Content-type': 'application/json',
      },
      data: form_data,
      withCredentials: true
    }).then(res => {
      if (!res.data.error) {
        setState({
          updatedPerks: res.data.updated_tier_perks,
        })
        if (props.current_page_view === 'platform'){
          props.handleTabNavigation('platform')
        } else {
          props.handleCollectionTabChange({}, collectionName)
        }
        setIsCreating(false);
        onClose();
      }
    }).catch(err => {
      setIsCreating(false);
    })
  }

  const deletePlaylist = () => {
    setIsCreating(true);

    const data = new FormData();
    data.append('playlist_name', collectionName);
    data.append('currency', currency)
    axios({
      method: 'post',
      url: paths.BACKEND_URL + 'api/influencer/onboarding_delete_playlist',
      data: data,
      headers: {
            'Content-type': 'application/json',
      },
      withCredentials: true
    }).then(
        res => {
          if (!res.data.access_denied){
              if (!res.data.error){
                onClose();
                setState({ courseNames: res.data.course_name_possibilites });
                props.handleProfileTabChange("", props.selected_tab);
              } else {
                if (res.data.error === 'course name exists'){
                    setErrorMessage('Course name already exists!');
                } else {
                    setErrorMessage('Error, please try again.');
                }
              }
          } else {

          }
        }
    ).finally(() => {
      setIsCreating(false);
    })
  }
      
  const handleSwitchChange = (event) => {
    const isChecked = event.target.checked;
    setState({ editCollectionBuyNowActive: isChecked });
    setBuyNowActive(isChecked);
    
    if (!isChecked) {
      // Clear price when turning off buy now
      setState({
        editCollectionPrice: 0,
        editCollectionPriceStr: ''
      });
    }
    // setPriceStr('');
  };

  useEffect(() => {
    if (isCourses) {
      handleSwitchChange({ target: { checked: true } });
    } else if (current_page_view === 'subscriptions') {
      handleSwitchChange({ target: { checked: false } });
    }
  },[current_page_view, open])

  const handleImageFiles = (file) => {
    setImageFile(file)
    setImagePreviewUrl(URL.createObjectURL(file));
};

const handleImagesOndragOver = (e) => {
    e.preventDefault();
};

useEffect(() => {
  setWindowWidth(window.innerWidth);
}, [window.innerWidth]);

// set current course/collection thumbnail as image preview url
useEffect(() => {
  if (editCollectionThumbnail && editCollectionThumbnail.includes('user_content')) {
    setImagePreviewUrl(editCollectionThumbnail)
  } else {
    setImagePreviewUrl('')
  }
}, [editCollectionThumbnail]);


// useEffect(() => {
//     console.log(imagePreviewUrl)
// }, [imagePreviewUrl]);

  return (
    <>
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="sm"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: '10px',
          margin: windowWidth < 600 ? '0px 0px 0px 0px' : '0px auto 0px auto',
          minWidth: windowWidth < 600 ? '100%': '320px',
          overflowY: 'auto',
          maxHeight: '100%',
        }
      }}
    >
      <Grid container
        style={{
          width: windowWidth < 600 ? '100%' : 'calc(100% - 60px)',
          justifyContent: 'center',
          alignItems: 'center',
          backgroundColor: 'white',
          height: 'auto',
          minWidth: '320px',
          padding: windowWidth < 600 ? '0px 20px 0px 20px' : '0px 0px 0px 0px',
          margin: windowWidth < 600 ? '20px 0px 10px 0px' : '20px auto 10px auto',
          maxHeight: '800px',
          display: 'flex',
        }}>
        <Grid lg={11} xs={11} >
          <h2>Edit {isCourses ? 'Course' : 'Collection'}</h2>
        </Grid>
        <Grid lg={1} xs={1}
          style={{
            top: '0px',
            padding: '0px',
            float: 'right',
            textAlign: 'right',
          }}
        >
          <div style={{ '&:hover': { cursor: 'pointer' } }}>
            <a onClick={onClose}>
              <IoClose className={'modal-close-icon'} style={{ width: '25px', height: '25px' }} />
            </a>
          </div>
        </Grid>
      </Grid>

      <div style={{
                 backgroundColor: '#D3DCE7',
                 margin: '0px auto 10px auto',
                 width: windowWidth < 600 ? 'calc(100% - 40px)' : 'calc(100% - 60px)',
                 height: '1px',
                 minHeight: '1px',
                 marginBottom: '10px',
                 padding: '0px 0px'
      }} />

<DialogContent sx={{ padding: windowWidth < 600 ? '0px 20px 0px 20px' : '0px 30px 0px 30px', overflow: 'initial' }}>

      <p className={'modal-title-text'}>{isCourses ? 'Course' : 'Collection'} Image (Optional)</p>
      {
          <p style={{ color: 'var(--secondary-icon-color)', marginTop: '5px', fontSize: '12px' }}><InfoIcon style={{fontSize: '14px', color: 'var(--secondary-icon-color)'}}/> If not added the frst content thumbnail will be displayed where possible.</p>
      }
                <>
                    {!imagePreviewUrl && <div
                        className="image-upload"
                        onDragOver={handleImagesOndragOver}
                        onDrop={(e) => {
                            e.preventDefault();
                            const file = e.dataTransfer.files[0];
                            
                            if (!file) return;

                            if (
                                file.type === 'image/jpeg' ||
                                file.type === 'image/jpg' ||
                                file.type === 'image/png'
                            ) {
                                if (file.size / Math.pow(1000, 3) >= 5) {
                                    setShowError(true)
                                    setErrorMessage("Your image exceeds the 5GB maximum file size limit. To reduce the size, consider lowering the resolution or converting to a different image format.")
                                } else {
                                    setImageFileTypeError('');
                                    handleImageFiles(file);
                                }
                            } else {
                                setShowError(true)
                                setErrorMessage("Unsupported file type. Please select an image with one of the following file types: .jpeg, .jpg, .png")
                            }
                        }}
                        onClick={() => imageInput.current.click()}
                        style={{
                            backgroundColor: '#eff2f6',
                            height: '100%',
                            width: '100%',
                            maxHeight: '150px',
                            maxWidth: '150px',
                            aspectRatio: '1 / 1',
                            position: 'relative',
                            border: '1px solid #D3DCE7',
                            borderRadius: '8px',
                            width: '100%',
                            maxWidth: '150px',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center',
                            aspectRatio: '1 / 1'
                        }}
                    >
                        <div style={{ margin: 'auto', }}>
                            <img src={IconImage} style={{ width: "20px", height: "20px" }} />
                            <br />
                            {
                                windowWidth >= 1200 ?
                                    <p className={'container_text'} color='#6D89AF' style={{ fontSize: '13px' }}>Drag your image here or <span style={{ color: '#3B55F3' }}>browse</span> </p>
                                    :
                                    <p className={'container_text'}><span style={{ color: '#3B55F3', fontSize: '13px' }}>Select your image</span></p>
                            }
                        </div>

                        <input
                            type="file"
                            accept=".jpeg,.jpg,.png"
                            ref={imageInput}
                            hidden
                            onChange={(e) => {
                                const file = e.target.files[0];
                                if (
                                    file.type === 'image/jpeg' ||
                                    file.type === 'image/jpg' ||
                                    file.type === 'image/png'
                                ) {
                                    if (file.size / Math.pow(1000, 3) >= 5) {
                                        setShowError(true)
                                        setErrorMessage('Your image exceeds the 5GB maximum file size limit. To reduce the size, consider lowering the resolution or converting to a different image format.')
                                    } else {
                                        setImageFileTypeError('');
                                        handleImageFiles(file);
                                    }
                                } else {
                                    setShowError(true)
                                    setErrorMessage('Unsupported file type. Please select an image with one of the following file types: .jpeg, .jpg, .png')
                                }
                            }}
                        />
                    </div>}
                    {imageFileTypeError &&
                        <p style={{ color: '#FD2B2B', marginTop: '5px', fontSize: '12px' }}>{imageFileTypeError}</p>
                    }
                    {imagePreviewUrl && (
                        <div key={0} style={{ width: '100%', marginBottom: '10px', display: 'flex', alignItems: 'center' }}>
                            <div className="image-uploaded-modal" style={{
                                backgroundColor: '#eff2f6',
                                height: '100%',
                                width: '100%',
                                maxHeight: '150px',
                                maxWidth: '150px',
                                aspectRatio: '1 / 1',
                                position: 'relative',
                                border: '1px solid #D3DCE7',
                                borderRadius: '8px',
                                width: '100%',
                                maxWidth: '150px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                aspectRatio: '1 / 1'
                            }}>
                                <img src={imagePreviewUrl} alt='Course image' style={{
                                    width: '100%',
                                    height: '100%',
                                    objectFit: 'cover',
                                    objectPosition: 'center'
                                }} />
                                <div
                                    onClick={() => {
                                        setImagePreviewUrl('');
                                    }}
                                    style={{
                                        position: 'absolute',
                                        top: '10px',
                                        right: '10px',
                                        width: '25px',
                                        height: '25px',
                                        backgroundColor: 'rgba(0, 0, 0, 0.6)',
                                        color: 'white',
                                        borderRadius: '50%',
                                        cursor: 'pointer',
                                        display: 'flex'
                                    }}
                                >
                                    <FaTrash style={{ fontSize: '12px', margin: 'auto' }} />
                                </div>
                            </div>
                        </div>
                    )}
                </>


                <div style={{
                    backgroundColor: '#D3DCE7',
                    margin: '30px auto 30px auto',
                    width: '100%',
                    height: '1px',
                    marginBottom: '10px',
                    padding: '0px 0px'
                }} />
        <p className={'modal-title-text'}>{isCourses ? 'Course' : 'Collection'} Name</p>
        <input
          type="text"
          id="collectionTitleInput"
          className={'text-input'}
          style={{
            display: 'block',
            fontWeight: '500',
            margin: '0px auto 15px auto',
            fontSize: '16px',
            padding: '10px 15px',
            color: '#1D1D1D',
            borderRadius: '5px',
            width: 'calc(100% - 30px)',
            fontFamily: 'Roboto'
          }}
          placeholder={`Enter ${isCourses ? 'course' : 'collection'} title`}
          value={collectionName}
          onChange={(e) => setCollectionName(e.target.value)}
        />

          {
            current_page_view !== 'subscriptions' && <>
              <div style={{ margin: '30px auto 0px auto', display: 'flex' }}>
                <p className={'modal-title-text'} style={{ margin: '0px 0px 15px 0px' }}>{isCourses ? 'Course price' : 'Sell this course?'}</p>

                {window.innerWidth > 900 ?
                  <LightTooltip title={`Sell this ${isCourses ? 'course' : 'collection'} to your audience as a one off purchase by adding a price. They will be able to purchase it from your collections.`} placement="top">
                    <span style={{ height: '100%' }}>
                      <PiInfoBold style={{ fontSize: '18px', margin: '0px 0px 0px 5px', color: '#4B6589' }} />
                    </span>
                  </LightTooltip>
                  : null
                }

                {!isCourses && <FormGroup sx={{ margin: '0px 0px 0px auto' }}>
                  <FormControlLabel
                    control={
                      <AntSwitch
                        checked={buyNowActive}
                        onChange={handleSwitchChange}
                      />
                    }
                    label={
                      <span style={{
                        fontSize: '13px',
                        margin: '0px 5px 0px 0px',
                        color: '#222222',
                        fontWeight: '500',
                        fontStyle: 'var(--main-font-family)',
                      }}>
                        {buyNowActive ? "Enabled" : "Disabled"}
                      </span>
                    }
                    labelPlacement="start"
                    style={{
                      fontSize: 'px !important',
                      marginRight: '5px',
                      color: 'black',
                      fontWeight: '600',
                      fontStyle: 'var(--main-font-family)',
                    }}
                  />
                </FormGroup>}
              </div>

              <Box sx={{ width: '100%' }}>
                <form style={{
                  backgroundColor: buyNowActive ? '#fff' : '#FAFAFA',
                  color: '#fff',
                  borderRadius: '5px',
                  padding: '0px 15px',
                  display: 'flex',
                  height: '46px',
                  margin: '0px 0px 0px 0px',
                  border: '1px solid #C7D1DE',
                  width: '100%',
                  maxWidth: '800px',
                  zIndex: '10',
                  boxSizing: 'border-box'
                }}>
                  <input type={"text"} id={"priceInput"}
                    disabled={!buyNowActive}
                    style={{
                      border: 'none', width: window.innerWidth > 560 ? '85%' : '72%', fontWeight: '500',
                      color: buyNowActive ? '#1D1D1D' : '#9CA3B3',
                      fontSize: '16px',
                      fontFamily: 'Roboto',
                    }}
                    value={currencySymbol + (editCollectionPrice !== 'none' && editCollectionPriceStr !== 0 ? editCollectionPriceStr : '') + currencySymbolPost}
                    onChange={(event) => {
                      let processed_str = event.target.value.replace(/[^0-9.]/g, '')

                      // Limit to 2 decimal places
                      if (processed_str.includes('.')) {
                        const [whole, decimal] = processed_str.split('.')
                        processed_str = whole + '.' + (decimal || '').slice(0, 2)
                      }

                      if (processed_str.includes('.')) {
                        let splits = processed_str.split('.')
                        let value = 0
                        if (splits[0].length === 0) {
                          value = 0
                        } else {
                          if (splits[1].length === 1) {
                            value = (Number(splits[0]) * 100) + (Number(splits[1]) * 10)
                          } else if (splits[1].length === 0) {
                            value = (Number(splits[0]) * 100)
                          } else {
                            value = (Number(splits[0]) * 100) + Number(splits[1])
                          }
                        }

                        if (value < 100) {
                          setErrorMessage(`Please enter a price greater than ${CreatePriceStr(currency === 'SEK' ? 1500 : 100, currency).replace('.00', '')}`)
                          setError(value < 100)
                          setState({
                            editCollectionPrice: value,
                            editCollectionPriceStr: processed_str,
                            error: value < 100,
                          });
                        } else {
                          setErrorMessage('')
                          setError(false)
                          setState({
                            editCollectionPrice: value,
                            editCollectionPriceStr: processed_str,
                            error: false,
                            error_message: ''
                          });
                        }
                      } else {
                        // Handle case where no decimal point exists
                        if (processed_str === '') {
                          setErrorMessage(`Please enter a price greater than ${CreatePriceStr(currency === 'SEK' ? 1500 : 100, currency).replace('.00', '')}`)
                          setError(true)
                          setState({
                            editCollectionPrice: 0,
                            editCollectionPriceStr: '',
                            error: true,
                          });
                        } else {
                          let value = Number(processed_str) * 100

                          if (value < 100) {
                            setErrorMessage(`Please enter a price greater than ${CreatePriceStr(currency === 'SEK' ? 1500 : 100, currency).replace('.00', '')}`)
                            setError(value < 100)
                            setState({
                              editCollectionPrice: value,
                              editCollectionPriceStr: processed_str,
                              error: value < 100,
                            });
                          } else {
                            setErrorMessage('')
                            setError(false)
                            setState({
                              editCollectionPrice: value,
                              editCollectionPriceStr: processed_str,
                              error: false,
                              error_message: ''
                            });
                          }
                        }
                      }
                    }}
                  />
                  <span style={{
                    fontWeight: '500',
                    margin: 'auto',
                    fontSize: '12px',
                    color: "grey",
                    minWidth: 'fit-content'
                  }}>
                    One time payment
                  </span>
                </form>
                {
                  error &&
                  <Grid container md={12} xs={12} sx={{ display: 'flex', justifyContent: 'flex-end', margin: '10px auto 0px auto' }}>
                    <div style={{ color: 'var(--danger-color)', fontWeight: '600', fontSize: '12px', margin: 'auto', lineHeight: '1.3', textAlign: 'center' }}>{errorMessage}</div>
                  </Grid>
                }
              </Box>
            </>
          }
      </DialogContent>
      
      <DialogActions sx={{ padding: windowWidth < 600 ? '30px 20px 70px 20px' : '30px', display: 'flex', justifyContent: 'space-between' }}>
        <Button Button
          variant="outlined"
          disableElevation
          disabled={!collectionName.trim() || (buyNowActive && errorMessage) || isCreateDisabled}
          sx={{
            padding: '8px 15px',
            width: 'auto',
            textAlign: 'center',
            display: 'inline-block',
            borderRadius: '10px',
            textTransform: 'none',
            border: '2px #FD2B2B solid',
            color: '#FD2B2B',
            backgroundColor: '#fff',
            '&:hover': {
                backgroundColor: '#FD2B2B',
                color: '#fff',
                border: '2px #FD2B2B solid',
            }
          }}
          onClick={async () => {
            deletePlaylist()
          }}
        >
          <span style={{ fontWeight: '600', fontSize: '15px' }}>
            Delete
          </span>
        </Button>
        <Button
          variant="contained"
          disableElevation
          disabled={!collectionName.trim() || (buyNowActive && errorMessage) || isCreateDisabled}
          sx={{
            padding: '8px 15px',
            width: 'auto',
            textAlign: 'center',
            display: 'inline-block',
            borderRadius: '10px',
            textTransform: 'none',
            border: !collectionName.trim() || isCreateDisabled ? '2px #E0E0E0 solid' : '2px var(--brand-color) solid',
            backgroundColor: !collectionName.trim() || isCreateDisabled ? '#FAFAFA' : 'var(--brand-color)',
            '&:hover': {
              backgroundColor: 'var(--brand-color-hover)',
              border: '2px var(--brand-color-hover) solid',
            }
          }}
          onClick={async () => {
            setIsCreating(true);
            const startTime = Date.now();
            
            await handleUpdate();

            // Ensure loading state shows for at least 500ms
            const elapsedTime = Date.now() - startTime;
            if (elapsedTime < 500) {
              await new Promise(resolve => setTimeout(resolve, 500 - elapsedTime));
            }
            
            setIsCreating(false);
          }}
        >
          <span style={{ fontWeight: '600', fontSize: '15px' }}>
            Update
          </span>
        </Button>
      </DialogActions>
      {isCreating && (
                    <div style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0, 0, 0, 0.1)',
                        zIndex: 1
                    }} />
                )}
    </Dialog>
    <Backdrop
    sx={{ 
        color: '#fff', 
        zIndex: 9999,
        backgroundColor: 'rgba(0, 0, 0, 0.7)'
    }}
    open={isCreating}
>
       <CircularProgress sx={{
      color: 'var(--brand-color)',
   }}/>
</Backdrop>
    </>
  );
};

export default EditCollections;
